import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=20c057d0&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=20c057d0&prod&scoped=true&lang=less&"
import style1 from "./Avatar.vue?vue&type=style&index=1&id=20c057d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c057d0",
  null
  
)

export default component.exports